import { useTheme } from "styled-components";
import SelectSurveys from "./SelectSurveys";

export default function Select (props) {
    const theme = useTheme();
    return (<SelectSurveys {...props} theme={theme} />
    );
  }